import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Team = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Team_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 7.25a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Zm1.625-2.625a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0ZM5.25 8.75C2.1 8.75 0 10.16 0 11.9 0 13.06.94 14 2.1 14h6.3a2.1 2.1 0 0 0 2.1-2.1c0-1.74-2.1-3.15-5.25-3.15ZM1 11.9c0-.423.249-.93.971-1.378.723-.448 1.841-.772 3.279-.772s2.556.324 3.279.772c.722.448.971.955.971 1.378A1.1 1.1 0 0 1 8.4 13H2.1A1.1 1.1 0 0 1 1 11.9ZM13.813 6.188a2.188 2.188 0 1 1-4.376 0 2.188 2.188 0 0 1 4.376 0Zm-1 0a1.188 1.188 0 1 1-2.376 0 1.188 1.188 0 0 1 2.376 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14h-3.57c.266-.288.478-.627.62-1h2.95a.75.75 0 0 0 .75-.75c0-.278-.161-.653-.73-1.006-.57-.354-1.47-.619-2.645-.619-.133 0-.263.003-.39.01a3.607 3.607 0 0 0-.614-.95c.318-.039.653-.06 1.004-.06C14.25 9.625 16 10.8 16 12.25A1.75 1.75 0 0 1 14.25 14Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Team_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Team;